import { gql } from '@apollo/client/core';
import { Trans } from '@lingui/macro';
import React from 'react';
import useProduct from '../useProduct';
import { DynamicComponent, Flex } from '../..';
import Awards from '../Awards/Awards';
import AwardsIcons from '../Awards/AwardsIcons';
import Certifications from '../Certifications/Certifications';
import CertificationsIcons from '../Certifications/CertificationsIcons';

/**
 * This component combines awards and cetifications into a single component.
 * This maximizes space on the page because it renders both awards and certifications
 * in the same row if there are less than 5.
 */
export default function Highlights({ product: data, style }) {
  const product = useProduct(data);
  if (!hasContent(product)) return null;

  return (
    <DynamicComponent.Wrapper style={style}>
      <DynamicComponent.Label style={{ marginBottom: 8 }}>
        <Trans>Highlights</Trans>
      </DynamicComponent.Label>
      <Flex>
        <AwardsIcons product={product} />
        <CertificationsIcons product={product} />
      </Flex>
    </DynamicComponent.Wrapper>
  );
}

Highlights.hasContent = hasContent;

function hasContent(product) {
  return Awards.hasContent(product) || Certifications.hasContent(product);
}

Highlights.fragment = gql`
  fragment Highlights on Product {
    ...Awards
    ...Certifications
  }
  ${Awards.fragment}
  ${Certifications.fragment}
`;
